// test list
// availableVideosList: [{id: 2,title: 'Video webtv-solution title movie 2',duration: '00:00:30',sources: [{src: '//argueii-web-dev.webtv-solution.com/uep_v2/videos/movie2.mp4',type: 'video/mp4'}],poster: '//i.ytimg.com/vi/RGHMz195wt8/maxresdefault.jpg'}],

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  zonnigRmbox: null,
  error: {},
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  /**
   * setZonnigRmbox
   *
   * @function   setZonnigRmbox
   */
  setZonnigRmbox(state, zonnigRmbox) {
    state.zonnigRmbox = zonnigRmbox;
  },
  setError(state, error) {
    state.error = { ...error };
  },
  setErrorId(state, errorId) {
    state.error = { ...state.error, id_error: errorId };
  },
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  setZonnigRmbox: ({ state, commit }, zonnigRmbox) => commit('setZonnigRmbox', zonnigRmbox),
  setError: ({ state, commit }, error) => commit('setError', error),
  setErrorId: ({ state, commit }, errorId) => commit('setErrorId', errorId),
};

// getters are functions
const getters = {
  /**
   * Get availableVideosList
   */
  getZonnigRmbox: state => state.zonnigRmbox,
  getError: state => state.error,
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/zonnig-config.js